import { citation, CitationResponse } from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

export type CitationSortOrder = 0 | 1;

export const getCitations = (
  id: string,
  payload: {
    page: number;
    page_size?: number;
    sort_by: CitationSortOrder;
  }
) => {
  const stringifiedPayload = Object.entries(payload)
    .filter(([_, value]) => value !== undefined)
    .reduce<Record<string, string>>((acc, [key, value]) => {
      acc[key] = value.toString();
      return acc;
    }, {});

  const params = new URLSearchParams(stringifiedPayload);
  return wretchRequest<CitationResponse>(
    citation.citationGroup.path(id, params)
  );
};
